/* eslint-disable @nx/enforce-module-boundaries */
import { Component, DestroyRef, OnChanges, OnInit, SimpleChanges, ViewChild, inject } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { VehicleTypesService } from 'admin-drivers/src/app/api/services/vehicle-types.service';
import { BaseDialogStepperFormComponent } from 'admin-drivers/src/app/common/dialog/base-dialog-stepper-form';
import { delay, take, tap } from 'rxjs';
import { VehicleTypeResponse } from 'admin-drivers/src/app/api/models/responses/VehicleTypeResponse';
import { VehicleType } from 'admin-drivers/src/app/common/models/VehicleType';

@Component({
  selector: 't-llevo-vehicle-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
  ],
  templateUrl: './vehicle-form.component.html',
  styles: `
    @import '../../../../utils/styles/formGroup.scss';

    form{
      mat-form-field {
        display: flex;
        width: 70% !important;
      }
    }
  `,
})
export class VehicleFormComponent extends BaseDialogStepperFormComponent<FormGroup> implements OnInit, OnChanges{
  private vehicleTypesSrv = inject(VehicleTypesService);
  private destroyRef = inject(DestroyRef);
  @ViewChild('firstInput') elementRef!: MatSelect

  protected vehicleTypes: VehicleType[] = [];
  protected colors = this.vehicleTypesSrv.vehicleColors;
  
  ngOnInit(): void {
    this.loaderId = this.loaderSrv.subscribe();
    this.vehicleTypesSrv.vehicleTypes$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .pipe(
        tap(() => {
          this.loaderSrv.show(this.loaderId);
        }),
        delay(100)
      )
      .subscribe({
        next: (data) => {
          if (data) {
            this.vehicleTypes = data;
            this.loaderSrv.hide(this.loaderId);

          } else {
            this.vehicleTypesSrv.getVehicleTypes().pipe(take(1)).subscribe();
          }
        },
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['focusOnFirstInput'] && this.focusOnFirstInput && this.loaderSrv.updatedCount > 0){
      setTimeout(()=>{this.elementRef._elementRef!.nativeElement.focus()}, 100)
    }
  }

  get vehicleType() {
    return this.frm.controls['vehicleType'];
  }

  get mark() {
    return this.frm.controls['mark'];
  }

  get model() {
    return this.frm.controls['model'];
  }

  get color() {
    return this.frm.controls['color'];
  }

  get plate() {
    return this.frm.controls['plate'];
  }
}
